module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.loading) ? _c('prb-loading') : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.errorPage) ? _c('v-layout', {
    staticClass: "target__layout text-xs-center",
    staticStyle: {
      "min-height": "70vh"
    },
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-5 white",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "title white"
  }, [_c('b', [_c('v-icon', {
    staticStyle: {
      "margin-bottom": "3px",
      "margin-right": "3px"
    }
  }, [_vm._v("error_outline")]), _vm._v("\n              Error: Data not found")], 1)])])], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.errorPage) ? _c('v-layout', {
    staticClass: "target__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target_layout__content elevation-1"
  }, [(_vm.titleName.length) ? _c('v-flex', {
    staticClass: "target__layout pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "target-top__layout__summary-title"
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs10": ""
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.titleName) + " | Probes List")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "xs2": ""
    }
  }, [(!_vm.loading) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Download full compounds report'
      }),
      expression: "{ html: 'Download full compounds report' }",
      arg: "left"
    }],
    staticClass: "white--text",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.downloadCsv(_vm.probes)
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("file_download")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.probes) ? _c('v-data-table', {
    staticClass: "elevation-0",
    attrs: {
      "id": "all-table",
      "headers": _vm.tableHeaders,
      "pagination": _vm.pagination,
      "items": _vm.probes,
      "search": _vm.tableSearch
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.header.text) + "\n              ")]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_c('img', {
          attrs: {
            "src": _vm.apiUrl + 'shared/ajax/get_compound_image.php?compound_id=' + props.item.id,
            "height": "100"
          }
        })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.nameProbe))]), _vm._v(" "), _c('td', _vm._l((_vm.tableFeatures), function(value, key) {
          return _c('img', {
            key: key,
            attrs: {
              "height": "25",
              "width": "25",
              "src": props.item[key] ? value.imageValid : value.imageInvalid
            }
          })
        })), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.global.toFixed(2)))]), _vm._v(" "), (props.item.chemical_probes_portal_rating.length) ? _c('td', [_c('a', {
          attrs: {
            "href": props.item.chemical_probes_portal_link,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(props.item.chemical_probes_portal_rating))])]) : _vm._e(), _vm._v(" "), (!props.item.chemical_probes_portal_rating.length) ? _c('td', [_vm._v("-")]) : _vm._e()])]
      }
    }])
  }) : _vm._e()], 1)])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-019027c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrbCompoundsAll.vue
// module id = 549
// module chunks = 1